export default __webpack_public_path__ + "static/media/work.5d8fa5e9.svg";